import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";

interface ConfirmDialogProps {
  open: boolean;
  title?: string;
  content?: string;
  cancelText?: string;
  confirmText?: string;
  onCancel: () => void;
  onConfirm: () => void;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  open,
  title = "확인",
  content = "이 작업을 진행하시겠습니까?",
  cancelText = "취소",
  confirmText = "확인",
  onCancel,
  onConfirm,
}) => (
  <Dialog open={open} onClose={onCancel} sx={{ "& .MuiDialog-paper": { minWidth: "400px", minHeight: "150px" } }}>
    <DialogTitle>{title}</DialogTitle>
    <DialogContent>{content}</DialogContent>
    <DialogActions sx={{ justifyContent: "center", p: 2 }}>
      <Button onClick={onCancel} variant='outlined'>
        {cancelText}
      </Button>
      <Button onClick={onConfirm} color='error' variant='contained'>
        {confirmText}
      </Button>
    </DialogActions>
  </Dialog>
);

export default ConfirmDialog;
